/**
 * Playing without seeing the board: /tools/blindfold.
 *
 * The game is the one the sparring partner plays anywhere else (`domain/playRules`), so what is
 * here is what makes it blindfold: how much of the position is allowed on the board, how many times
 * it was peeked at, and what the last move typed was answered with.
 */
export const blindfoldSlice = {
    // idle: choosing | playing | finished
    status: "idle",
    side: "white",        // the side the user plays, decided when the game starts
    strength: "casual",   // key of domain/playRules STRENGTHS
    help: "last",         // key of domain/blindfold HELPS
    thinking: false,      // the partner is looking for its move
    peeking: false,       // the board is showing everything, for a few seconds
    peeks: 0,             // how many times it was asked for, which costs XP
    error: null,          // what was wrong with the move that was typed
    outcome: null,        // { over, result, reason, winner, verdict } once it is over
    xp: 0,
    saved: false,
    pgn: null,            // the finished game, for the file and for Lichess
    fen: null,            // where it ended
    revealed: false,      // the board is up again mid-game: the exercise stopped, the game did not
    moves: [],            // the moves of the game, kept whole for walking through it afterwards
    reviewPly: null,      // which move is being looked at once it is over; null is the end
    keypad: false,        // moves pressed on a keypad rather than typed, which is what a phone wants
};
